module.exports = __webpack_public_path__ + "img/red3.cec14ebd.svg";